import ClientsAxios from '../client-axios';
import { ResponseEntity } from '../dto/response';

const { API_SERVER } = ClientsAxios;

export const CsrUserListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('csr-user/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const CsrUserStoreService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('csr-user/create', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const CsrUserUpdateService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('csr-user/update', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.message, response?.data?.body ?? null)
    }
    return responseEntity
}
